import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap'

export default function PortofolioPost(dataKategori){

    const DataURL = 'https://docs.google.com/spreadsheets/d/1cAwvX7mu4HWwgc2qhAUXemqA40gj0_zlVNi9YfMEyIs/gviz/tq?/sheet=SANS_IT'
    const [data, setData] = useState([]);

    useEffect(() => {
        fetch(DataURL)
            .then(res => res.text())
            .then(res => {
            const API = JSON.parse(res.substr(47).slice(0,-2))
        
            const rows = API.table.rows;
    
            setData(rows.map((dataRow) => {
                const gambar = dataRow.c[1].v;
                const nama = dataRow.c[2].v;
                const URL = dataRow.c[3].v;
                const deskripsi = dataRow.c[4].v;
    
                const companyProfile = dataRow.c[5].v;
                const personal = dataRow.c[6].v;
                const business = dataRow.c[7].v;
                return {...data,
                    nama: nama,
                    deskripsi: deskripsi,
                    gambar: gambar,
                    link: URL,
                    kategori: [                        
                        companyProfile,
                        personal,
                        business
                    ]
                }     
            }))
        })
    },[])

    const filterKategori = data.filter(data =>
        data.kategori
    ).filter(obj => {
        if (dataKategori.kategori === 'All') {return obj} 
        else {
            return obj.kategori.includes(dataKategori.kategori)
        }
    })

    return (
    <>
        {/* Portofolio Post */}
        {filterKategori.length !== 0 ? filterKategori.map((post,index) => {   
            return <div className='col-lg-4 col-md-6' key={index}>
                <div className="card w-100 mb-4 overflow-hidden" style={{width:'18rem'}}>
                    <img src={post.gambar} className="card-img-top" alt={post.nama} loading="lazy"/>
                    <div className="card-body p-4">
                        <h4 className="card-title fw-semibold">{post.nama}</h4>
                        <p className="card-text">{post.deskripsi}</p>
                        <Button href={post.link} target='_blank'>Lihat Portofolio</Button>
                    </div>
                </div>
            </div>
        }) : <div className='col-lg-12 w-100' style={{height:'250px'}}>
            <h5 className='text-center'>NOT AVAILABLE</h5>
        </div>}
    </>
    )
}